<template>
    <v-container fluid>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col>
                <v-btn width="100" color="primary" @click="lastWeek()">＜＜前週</v-btn>
            </v-col>
            <v-col class="text-center">
                <v-btn width="100" color="primary" @click="thisWeek()">今週</v-btn>
            </v-col>
            <v-col class="text-right">
                <v-btn width="100" color="primary" @click="nextWeek()">次週＞＞</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card class="mt-3 pb-5">
                    <v-sheet :height="calendarHeight">
                        <h1 class="text-center pa-3">{{ dbDevice.name }}</h1>
                        <v-calendar ref="calendar" :now="today" :value="dispDate" :events="events" color="primary" type="week" @click:event="feedPlanClick" :weekdays="weekdays" interval-width="40" :interval-height="intervalHeight" locale="jp"></v-calendar>
                        <h5 class="text-center">{{ dispWeekSpan }}</h5>
                    </v-sheet>
                    <!-- ====================== -->
                    <v-speed-dial direction="bottom" top left v-model="speedDialSlide" transition="scale-transition" style="position: absolute">
                        <template v-slot:activator>
                            <v-btn v-model="speedDialSlide" color="purple darken-1" dark fab>
                                <v-icon v-if="speedDialSlide">mdi-close</v-icon>
                                <v-icon v-else>mdi-arrow-expand-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-card outlined height="200" width="60" color="grey">
                            <v-slider vertical v-model="intervalHeight" min="30" max="1200" @change="setIntervalHeight()"></v-slider>
                        </v-card>
                    </v-speed-dial>
                    <!-- ====================== -->
                    <v-speed-dial direction="left" bottom right v-model="speedDialBtn" transition="scale-transition" style="position: absolute">
                        <template v-slot:activator>
                            <v-btn v-model="speedDialBtn" color="purple darken-1" dark fab>
                                <v-icon v-if="speedDialBtn">mdi-close</v-icon>
                                <v-icon v-else>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <v-btn dark small color="green" @click="newFeedPlanClick('timer')"> タイマー </v-btn>
                        <v-btn dark small color="warning" @click="newFeedPlanClick('self')"> 自発 </v-btn>
                        <v-btn dark small color="pink" @click="newFeedPlanClick('ai')"> AI </v-btn>
                    </v-speed-dial>
                    <!-- ====================== -->
                </v-card>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="confirmDeleteDlg" persistent>
            <v-card>
                <v-toolbar color="indigo" dark>確認</v-toolbar>
                <v-card-title>
                    <h5>「{{ dlgFeedPlan.name }}」を削除してもよろしいですか？</h5>
                </v-card-title>
                <v-card-actions>
                    <v-btn width="100" color="error" class="float-left" @click="axiosDeleteFeedPlan()">削除！</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn width="100" color="success" outlined @click="confirmDeleteDlg = false">キャンセル</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="dispPlanDlg" fullscreen transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="indigo">
                    <v-toolbar-title>給餌プラン設定</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dispPlanDlg = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>

                <!-- ====================== -->
                <v-card-text class="mt-5 pr-0">
                    <v-container>
                        <v-row>
                            <v-col>
                                <v-text-field v-model="dlgFeedPlan.name" label="タイトル" dense :rules="[rules.required]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-dialog v-model="dispClockDlg" :return-value.sync="dlgFeedPlan.stime" persistent width="290px" ref="stimeDialog">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="dlgFeedPlan.stime" label="開始時刻" readonly v-bind="attrs" v-on="on" dense></v-text-field>
                                    </template>
                                    <v-time-picker v-if="dispClockDlg" v-model="dlgFeedPlan.stime" full-width format="24hr">
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="dispClockDlg = false"> Cancel </v-btn>
                                        <v-btn text color="primary" @click="$refs.stimeDialog.save(dlgFeedPlan.stime)"> OK </v-btn>
                                    </v-time-picker>
                                </v-dialog>
                            </v-col>
                            <v-col>
                                <v-select label="動作時間(分)" v-model="dlgFeedPlan.minutes" :items="optMinutes" dense :rules="[rules.required]"></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="8">
                                <v-select label="ルーティーン" @change="routineChange" v-model="dlgFeedPlan.routine" :items="optRoutines" multiple dense></v-select>
                            </v-col>
                            <v-col>
                                <v-dialog v-model="dispMonthDlg" :return-value.sync="dlgFeedPlan.zero_date" persistent width="290px" ref="zeroDateDialog">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="dlgFeedPlan.zero_date" label="中日計算基準日" readonly v-bind="attrs" v-on="on" dense></v-text-field>
                                    </template>
                                    <v-date-picker v-model="dlgFeedPlan.zero_date" locale="jp" :max="today">
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="dispMonthDlg = false"> Cancel </v-btn>
                                        <v-btn text color="primary" @click="$refs.zeroDateDialog.save(dlgFeedPlan.zero_date)"> OK </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <!-- ====================== -->
                <v-card-text class="mt-5 pr-0">
                    <!-- --------------------- -->
                    <div v-if="dlgFeedPlan.mode == 'timer'">
                        <v-container>
                            <!--
                            <v-row>
                                <v-col>
                                    <h5>給餌量(kg)</h5>
                                    <v-slider v-model="dlgFeedPlan.detail.timer_weight" class="align-center" :min="outputMin" :max="outputMax" step="0.001" hide-details>
                                        <template v-slot:append>
                                            <v-text-field v-model="dlgFeedPlan.detail.timer_weight" class="mt-0 pt-0" hide-details single-line type="number" step="0.001" style="width: 100px"></v-text-field>
                                        </template>
                                    </v-slider>
                                </v-col>
                            </v-row>
                            -->
                            <v-row>
                                <v-col>
                                    <h5>給餌量（{{ outputMin }} kg 〜 {{ outputMax }} kg）</h5>
                                    <v-text-field v-model="dlgFeedPlan.detail.timer_weight" class="mt-0 pt-0" hide-details single-line step="0.1" inputmode="decimal" outlined dense></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <h5>飛散レベル</h5>
                                    <v-slider v-model="dlgFeedPlan.splinkle" class="align-center" max="9" min="1" hide-details>
                                        <template v-slot:append>
                                            <v-text-field v-model="dlgFeedPlan.splinkle" class="mt-0 pt-0" hide-details single-line type="number" style="width: 100px" readonly></v-text-field>
                                        </template>
                                    </v-slider>
                                </v-col>
                            </v-row>
                        </v-container>
                    </div>
                    <!-- --------------------- -->
                    <div v-if="dlgFeedPlan.mode == 'self'">
                        <v-container>
                            <!--
                            <v-row>
                                <v-col>
                                    <h5>1回あたりの給餌量(kg)</h5>
                                    <v-slider v-model="dlgFeedPlan.detail.self_shot_weight" class="align-center" max="3" min="0.1" step="0.1" hide-details>
                                        <template v-slot:append>
                                            <v-text-field v-model="dlgFeedPlan.detail.self_shot_weight" class="mt-0 pt-0" hide-details single-line type="number" style="width: 60px" readonly></v-text-field>
                                        </template>
                                    </v-slider>
                                </v-col>
                            </v-row>
                            -->
                            <v-row>
                                <v-col>
                                    <h5>1回あたりの給餌量(0.1kg 〜 3.0kg)</h5>
                                    <v-text-field v-model="dlgFeedPlan.detail.self_shot_weight" class="mt-0 pt-0" hide-details single-line step="0.1" inputmode="decimal" outlined dense></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <h5>飛散レベル</h5>
                                    <v-slider v-model="dlgFeedPlan.splinkle" class="align-center" max="9" min="1" hide-details>
                                        <template v-slot:append>
                                            <v-text-field v-model="dlgFeedPlan.splinkle" class="mt-0 pt-0" hide-details single-line type="number" style="width: 60px" readonly></v-text-field>
                                        </template>
                                    </v-slider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <h5>日の出増量時間(分)</h5>
                                    <v-slider v-model="dlgFeedPlan.detail.self_sunrise" class="align-center" max="90" min="0" step="15" hide-details>
                                        <template v-slot:append>
                                            <v-text-field v-model="dlgFeedPlan.detail.self_sunrise" class="mt-0 pt-0" hide-details single-line type="number" style="width: 60px" readonly></v-text-field>
                                        </template>
                                    </v-slider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <h5>日の入り増量時間(分)</h5>
                                    <v-slider v-model="dlgFeedPlan.detail.self_sunset" class="align-center" max="90" min="0" step="15" hide-details>
                                        <template v-slot:append>
                                            <v-text-field v-model="dlgFeedPlan.detail.self_sunset" class="mt-0 pt-0" hide-details single-line type="number" style="width: 60px" readonly></v-text-field>
                                        </template>
                                    </v-slider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <h5>朝夕増量(倍率)</h5>
                                    <v-slider v-model="dlgFeedPlan.detail.self_extra" class="align-center" max="3" min="0" step="0.5" hide-details>
                                        <template v-slot:append>
                                            <v-text-field v-model="dlgFeedPlan.detail.self_extra" class="mt-0 pt-0" hide-details single-line type="number" style="width: 60px" readonly></v-text-field>
                                        </template>
                                    </v-slider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <div class="mt-5">
                                        <v-select outlined dense label="地域コード" v-model="dlgFeedPlan.detail.self_region_code" :items="optSelfRegion"></v-select>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </div>
                    <!-- --------------------- -->
                    <div v-if="dlgFeedPlan.mode == 'ai'">
                        <v-container>
                            <h2 class="mb-5">■引寄せ給餌</h2>
                            <v-row class="px-5">
                                <v-col class="py-0" cols="6">
                                    <v-select outlined dense label="引寄せ給餌速度" :items="optMotor" v-model="dlgFeedPlan.detail.ai_start_motor"></v-select>
                                </v-col>
                                <v-col class="py-0" cols="6">
                                    <v-select outlined dense label="引寄せ時間" :items="optSecounds" v-model="dlgFeedPlan.detail.ai_start_delay"></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-container>
                            <h2 class="mb-5">■AI判定給餌</h2>
                            <v-row class="px-5">
                                <v-col class="py-0">
                                    <v-select outlined dense label="活性度5の給餌速度" :items="optMotor" v-model="dlgFeedPlan.detail.ai_lvl5_motor"></v-select>
                                </v-col>
                            </v-row>
                            <v-row class="px-5">
                                <v-col class="py-0">
                                    <v-select outlined dense label="活性度4の給餌速度" :items="optMotor" v-model="dlgFeedPlan.detail.ai_lvl4_motor"></v-select>
                                </v-col>
                            </v-row>
                            <v-row class="px-5">
                                <v-col class="py-0">
                                    <v-select outlined dense label="活性度3の給餌速度" :items="optMotor" v-model="dlgFeedPlan.detail.ai_lvl3_motor"></v-select>
                                </v-col>
                            </v-row>
                            <v-row class="px-5">
                                <v-col class="py-0">
                                    <v-select outlined dense label="活性度2の給餌速度" :items="optMotor" v-model="dlgFeedPlan.detail.ai_lvl2_motor"></v-select>
                                </v-col>
                            </v-row>
                            <v-row class="px-5">
                                <v-col class="py-0">
                                    <v-select outlined dense label="活性度1の給餌速度" :items="optMotor" v-model="dlgFeedPlan.detail.ai_lvl1_motor"></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-container>
                            <h2 class="mb-5">■AI判定感度</h2>
                            <v-row class="px-5">
                                <v-col class="py-0" cols="6">
                                    <v-select outlined dense label="感度" :items="optAiSensitive" v-model="dlgFeedPlan.detail.ai_sensitive"></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-container>
                            <h2 class="mb-5">■AI給餌サイクル</h2>
                            <v-row class="px-5">
                                <v-col class="py-0" cols="6">
                                    <v-select outlined dense label="サイクル数" :items="optAiRepeat" v-model="dlgFeedPlan.detail.ai_repeat"></v-select>
                                </v-col>
                                <v-col class="py-0" cols="6">
                                    <v-select outlined dense label="インターバル" :items="optIntervals" v-model="dlgFeedPlan.detail.ai_repeat_interval"></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-container>
                            <h2 class="mb-5">■その他設定</h2>
                            <v-row class="px-5">
                                <v-col class="py-0">
                                    <v-select outlined dense label="飛散レベル" :items="optMotorSprinkle" v-model="dlgFeedPlan.splinkle"></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </div>
                    <!-- --------------------- -->
                </v-card-text>
                <!-- ====================== -->
                <v-divider></v-divider>
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col class="text-center pa-0" v-show="dlgFeedPlan.id > 0">
                            <v-btn color="error" @click="confirmDeleteDlg = true" width="100">削除</v-btn>
                        </v-col>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="dispPlanDlg = false" width="100" outlined>キャンセル</v-btn>
                        </v-col>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="axiosSubmitFeedPlan()" width="100">登録</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <!-- ====================== -->
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
    </v-container>
</template>

<script>
import Config from "@/config.json";
import mqtt from "mqtt";
export default {
    name: "FeedPlan",
    //#####################################################################################################
    data() {
        return {
            jwt: "",
            myInfo: [],
            device_id: 0,
            dbDevice: { id: 0, name: "", feeder_id: 0 },
            dbFeeder: { id: 0, name: "", pellet: "", output1: "1000", output9: "9000" },
            dbFeedPlans: [],
            //-----------------------------
            mqttHost: Config.mqttHost,
            mqttID: Config.mqttID,
            mqttPW: Config.mqttPW,
            mqttTopicPub: Config.mqttTopicPub,
            mqttTopicSub: Config.mqttTopicSub,
            mqttClient: { connected: false },
            //-----------------------------
            intervalHeight: 80,
            //-----------------------------
            dlgFeedPlan: {
                id: 0,
                site_id: 0,
                device_id: 0,
                mode: "ai",
                name: "タイトル",
                stime: "06:30",
                minutes: "90",
                routine: ["月", "水", "金"],
                zero_date: this.$moment().format("YYYY-MM-DD"),
                splinkle: 3,
                detail: {
                    timer_weight: "100",
                    //------------------------
                    ai_start_motor: 3,
                    ai_start_delay: 10,
                    ai_lvl5_motor: 9,
                    ai_lvl4_motor: 7,
                    ai_lvl3_motor: 5,
                    ai_lvl2_motor: 2,
                    ai_lvl1_motor: 0,
                    ai_sensitive: 1, // 1=敏感、3＝鈍感
                    ai_repeat: 1,
                    ai_repeat_interval: 10,
                    //------------------------
                    self_shot_weight: "10", //自発のショット給餌量
                    self_sunrise: "15", //日の出まずめ
                    self_sunset: "15",
                    self_extra: "1.5", //増量
                    self_region_code: "A", //地域コード
                },
            },
            dispPlanDlg: false,
            dispMonthDlg: false,
            dispClockDlg: false,
            confirmDeleteDlg: false,
            //----
            optMotor: [
                { value: "9", text: "9" },
                { value: "8", text: "8" },
                { value: "7", text: "7" },
                { value: "6", text: "6" },
                { value: "5", text: "5" },
                { value: "4", text: "4" },
                { value: "3", text: "3" },
                { value: "2", text: "2" },
                { value: "1", text: "1" },
                { value: "0", text: "0" },
            ],
            optAiSensitive: [
                { value: "1", text: "高" },
                { value: "2", text: "中" },
                { value: "3", text: "低" },
            ],
            optMotorSprinkle: [
                { value: 9, text: "9" },
                { value: 8, text: "8" },
                { value: 7, text: "7" },
                { value: 6, text: "6" },
                { value: 5, text: "5" },
                { value: 4, text: "4" },
                { value: 3, text: "3" },
                { value: 2, text: "2" },
                { value: 1, text: "1" },
            ],
            optSecounds: [
                { value: "0", text: "なし" },
                { value: "3", text: "3秒" },
                { value: "5", text: "5秒" },
                { value: "10", text: "10秒" },
                { value: "15", text: "15秒" },
                { value: "20", text: "20秒" },
                { value: "30", text: "30秒" },
                { value: "40", text: "40秒" },
                { value: "50", text: "50秒" },
                { value: "60", text: "60秒" },
                { value: "70", text: "70秒" },
                { value: "80", text: "80秒" },
                { value: "90", text: "90秒" },
                { value: "100", text: "100秒" },
                { value: "110", text: "110秒" },
                { value: "120", text: "120秒" },
                { value: "130", text: "130秒" },
                { value: "140", text: "140秒" },
                { value: "150", text: "150秒" },
                { value: "160", text: "160秒" },
                { value: "170", text: "170秒" },
                { value: "180", text: "180秒" },
                { value: "190", text: "190秒" },
                { value: "200", text: "200秒" },
                { value: "220", text: "220秒" },
                { value: "240", text: "240秒" },
                { value: "260", text: "260秒" },
                { value: "280", text: "280秒" },
                { value: "300", text: "300秒" },
            ],
            optIntervals: [
                { value: "10", text: "10秒" },
                { value: "20", text: "20秒" },
                { value: "30", text: "30秒" },
                { value: "40", text: "40秒" },
                { value: "50", text: "50秒" },
                { value: "60", text: "60秒" },
                { value: "70", text: "70秒" },
                { value: "80", text: "80秒" },
                { value: "90", text: "90秒" },
                { value: "100", text: "100秒" },
                { value: "110", text: "110秒" },
                { value: "120", text: "120秒" },
                { value: "130", text: "130秒" },
                { value: "140", text: "140秒" },
                { value: "150", text: "150秒" },
                { value: "160", text: "160秒" },
                { value: "170", text: "170秒" },
                { value: "180", text: "180秒" },
                { value: "190", text: "190秒" },
                { value: "200", text: "200秒" },
                { value: "220", text: "220秒" },
                { value: "240", text: "240秒" },
                { value: "260", text: "260秒" },
                { value: "280", text: "280秒" },
                { value: "300", text: "300秒" },
            ],
            //----
            optRoutines: [
                { value: "毎日", text: "毎日", disabled: false },
                { divider: true },
                { value: "月", text: "月曜", disabled: false },
                { value: "火", text: "火曜", disabled: false },
                { value: "水", text: "水曜", disabled: false },
                { value: "木", text: "木曜", disabled: false },
                { value: "金", text: "金曜", disabled: false },
                { value: "土", text: "土曜", disabled: false },
                { value: "日", text: "日曜", disabled: false },
                { divider: true },
                { value: "中一", text: "中1日", disabled: false },
                { value: "中二", text: "中2日", disabled: false },
                { value: "中三", text: "中3日", disabled: false },
                { value: "中四", text: "中4日", disabled: false },
                { value: "中五", text: "中5日", disabled: false },
            ],
            optMinutes: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "20", "30", "40", "50", "60", "90", "120"],
            optAiRepeat: ["1", "2", "3", "4", "5"],
            optAiInterval: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
            optSelfRegion: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"],
            //----
            outputMin: 0.001,
            outputMax: 99,
            //----
            dispDate: this.$moment().format("YYYY-MM-DD"),
            today: this.$moment().format("YYYY-MM-DD"),
            events: [],
            weekdays: [0, 1, 2, 3, 4, 5, 6],
            //----
            speedDialSlide: false,
            speedDialBtn: false,
            //----
            aiLabel: ["A:高活性", "B", "C:中活性", "D", "E:低活性", "インターバル"],
            aiValue: [9, 7, 2, 0],
            //----
            rules: { required: (value) => !!value || "Required." },
            //----
            windowWidth: window.innerWidth, // 画面サイズ
            windowHeight: window.innerHeight, //画面サイズ
            isLoading: false,
        };
    },
    //#####################################################################################################
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------------------------------
        // カレンダーの時間毎の高さ
        if (this.$localStorage.get("intervalHeight")) {
            this.intervalHeight = this.$localStorage.get("intervalHeight");
        }
        //-----------------------------------------------
        this.device_id = this.$route.params.device_id;
        //-----------------------------------------------
        this.isLoading = true;
        //-----------------------------------------------
        //非同期でAxiosGet
        const promiseDevice = this.axiosGetDevices(this.device_id);
        await promiseDevice;
        const promiseFeeder = this.axiosGetFeeders(this.dbDevice.feeder_id);
        const promisePlan = this.axiosGetFeedPlan();
        //-----------------------------------------------
        //上記の終了を待つ
        await promiseFeeder;
        await promisePlan;
        //-----------------------------------------------
        await new Promise((r) => setTimeout(r, 500));
        //-----------------------------------------------
        this.isLoading = false;
        //-----------------------------------------------
        this.connectMqtt(); //MQTT コネクト
        //-----------------------------------------------
        window.scrollTo(0, 0);
    },
    //#####################################################################################################
    computed: {
        dispWeekSpan: function () {
            let weekNo = this.$moment(this.dispDate).day();
            let sdate = this.$moment(this.dispDate).add(-weekNo, "day").format("YYYY/M/D");
            let edate = this.$moment(this.dispDate)
                .add(6 - weekNo, "day")
                .format("M/D");
            return sdate + " 〜 " + edate;
        },
        //===================================================
        calendarHeight: function () {
            let calHight = window.innerHeight - 250;
            if (calHight < 300) calHight = 300;
            return calHight;
        },
        //===================================================
        // WatchでDeepを使用すると、newVal,oldValが同じになってしまうのでComputedを通す
        computedDlgFeedPlan() {
            return JSON.parse(JSON.stringify(this.dlgFeedPlan));
        },
        //===================================================
    },
    //#####################################################################################################
    watch: {
        computedDlgFeedPlan: {
            deep: true,
            handler(newVal, oldVal) {
                //const minutes = Number(this.dlgFeedPlan["minutes"]);
                if (newVal.minutes != oldVal.minutes) {
                    // const o9 = Number(this.dbFeeder["output9"]); //グラム
                    // let max = o9 * minutes;
                    // max = max / 1000; //グラム-> キログラム
                    // max = Math.round(max * 10) / 10;
                    // this.outputMax = max <= 0 ? 0.1 : max;
                    // //------------------------------
                    // const o1 = Number(this.dbFeeder["output1"]); //グラム
                    // let min = o1 / 60;
                    // min = min * minutes;
                    // min = min / 1000; //グラム-> キログラム
                    // min = Math.round(min * 10) / 10;
                    // min = min > 0.1 ? min : 0.1;
                    // this.outputMin = min;
                    // //------------------------------
                    self.console.log("----------- watch -------------------");
                    self.console.log(newVal);
                    this.calcOutputMinMax();
                }
            },
        },
    },
    //#####################################################################################################
    mounted: function () {
        window.addEventListener("resize", this.handleResize);
        //カレンダースクロール
        const thisTime = this.$moment().add(-3, "hours").format("HH:mm");
        this.$refs.calendar.scrollToTime(thisTime);
    },
    //#####################################################################################################
    beforeDestroy: function () {
        window.removeEventListener("resize", this.handleResize);
        this.disconnectMqtt(); //MQTT 切断
    },
    //#####################################################################################################
    methods: {
        //===================================================
        handleResize: function () {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
        },
        //===================================================
        // 表示する週のボタン
        //===================================================
        thisWeek() {
            this.dispDate = this.$moment().format("YYYY-MM-DD");
            this.createWeekEvent();
        },
        nextWeek() {
            this.dispDate = this.$moment(this.dispDate).add(7, "days").format("YYYY-MM-DD");
            this.createWeekEvent();
        },
        lastWeek() {
            this.dispDate = this.$moment(this.dispDate).add(-7, "days").format("YYYY-MM-DD");
            this.createWeekEvent();
        },
        //===================================================
        setIntervalHeight() {
            this.$localStorage.set("intervalHeight", this.intervalHeight);
        },
        //===================================================
        calcOutputMinMax() {
            self.console.log("------------------ calcOutputMinMax ----------------");

            const minutes = Number(this.dlgFeedPlan["minutes"]);
            //------------------------------
            //const o9 = Number(this.dbFeeder["output9"]) / 1000; //グラム-> キログラム
            const o9 = Number(this.dbFeeder["output9"]); //グラム
            let max = o9 * minutes;
            max = max / 1000; //グラム-> キログラム
            max = Math.round(max * 10) / 10;
            this.outputMax = max <= 0 ? 0.1 : max;
            //------------------------------
            const o1 = Number(this.dbFeeder["output1"]) / 1000; //グラム-> キログラム
            let min = o1 / 60;
            min = min * minutes;
            min = min / 1000; //グラム-> キログラム
            min = Math.round(min * 10) / 10;
            min = min > 0.1 ? min : 0.1;
            this.outputMin = min;
        },
        //===================================================
        // 選択項目によって、他をDisabledにする
        //===================================================
        routineChange(selectedAry) {
            //self.console.log(selectedAry);
            if (selectedAry.length == 0) {
                for (let i in this.optRoutines) {
                    this.optRoutines[i]["disabled"] = false;
                }
                return true;
            }
            for (let selectedItem of selectedAry) {
                let chkAry = [];
                //---------------------
                chkAry = ["毎日"];
                if (chkAry.includes(selectedItem)) {
                    for (let i in this.optRoutines) {
                        let val = this.optRoutines[i]["value"];
                        if (chkAry.includes(val)) {
                            this.optRoutines[i]["disabled"] = false;
                        } else {
                            this.optRoutines[i]["disabled"] = true;
                        }
                    }
                    let tmpSelectedAry = [];
                    for (let i in this.dlgFeedPlan.routine) {
                        let val = this.dlgFeedPlan.routine[i];
                        if (chkAry.includes(val)) {
                            tmpSelectedAry.push(val);
                        }
                    }
                    this.dlgFeedPlan.routine = tmpSelectedAry;
                    return true;
                }
                //---------------------
                chkAry = ["月", "火", "水", "木", "金", "土", "日"];
                if (chkAry.includes(selectedItem)) {
                    for (let i in this.optRoutines) {
                        let val = this.optRoutines[i]["value"];
                        if (chkAry.includes(val)) {
                            this.optRoutines[i]["disabled"] = false;
                        } else {
                            this.optRoutines[i]["disabled"] = true;
                        }
                    }
                    let tmpSelectedAry = [];
                    for (let i in this.dlgFeedPlan.routine) {
                        let val = this.dlgFeedPlan.routine[i];
                        if (chkAry.includes(val)) {
                            tmpSelectedAry.push(val);
                        }
                    }
                    this.dlgFeedPlan.routine = tmpSelectedAry;
                    return true;
                }
                //---------------------
                chkAry = ["中一", "中二", "中三", "中四", "中五"];
                if (chkAry.includes(selectedItem)) {
                    for (let i in this.optRoutines) {
                        let val = this.optRoutines[i]["value"];
                        if (chkAry.includes(val) && val == selectedItem) {
                            this.optRoutines[i]["disabled"] = false;
                        } else {
                            this.optRoutines[i]["disabled"] = true;
                        }
                    }
                    let tmpSelectedAry = [];
                    for (let i in this.dlgFeedPlan.routine) {
                        let val = this.dlgFeedPlan.routine[i];
                        if (chkAry.includes(val) && val == selectedItem) {
                            tmpSelectedAry.push(val);
                        }
                    }
                    this.dlgFeedPlan.routine = tmpSelectedAry;
                    return true;
                }
                //---------------------
            }
        },
        //===================================================
        // 週カレンダー表示用データを生成
        //===================================================
        createWeekEvent() {
            this.events = [];
            const weekAry = ["日", "月", "火", "水", "木", "金", "土"];
            for (let feedPlan of this.dbFeedPlans) {
                for (let i = -7; i <= 7; i++) {
                    let addFlg = false;
                    //----------------------------------------------------
                    if (feedPlan.routine.indexOf("毎日") != -1) addFlg = true;
                    //----------------------------------------------------
                    let weekNo = this.$moment(this.dispDate).add(i, "day").day(); // [0=日、1=月、2=火、3=水、4=木、5=金、6=土]
                    let weekStr = weekAry[weekNo];
                    if (feedPlan.routine.indexOf(weekStr) != -1) addFlg = true;
                    //----------------------------------------------------
                    let dateA = this.$moment(feedPlan.zero_date);
                    let dateB = this.$moment(this.dispDate).add(i, "day");
                    let diffDay = dateB.diff(dateA, "days");
                    //self.console.log(diffDay);
                    if (feedPlan.routine.indexOf("中一") != -1) {
                        if (diffDay % 2 == 0) addFlg = true;
                    }
                    if (feedPlan.routine.indexOf("中二") != -1) {
                        if (diffDay % 3 == 0) addFlg = true;
                    }
                    if (feedPlan.routine.indexOf("中三") != -1) {
                        if (diffDay % 4 == 0) addFlg = true;
                    }
                    if (feedPlan.routine.indexOf("中四") != -1) {
                        if (diffDay % 5 == 0) addFlg = true;
                    }
                    if (feedPlan.routine.indexOf("中五") != -1) {
                        if (diffDay % 6 == 0) addFlg = true;
                    }
                    if (feedPlan.routine.indexOf("中六") != -1) {
                        if (diffDay % 7 == 0) addFlg = true;
                    }
                    //----------------------------------------------------
                    if (this.$moment(this.dispDate).add(i, "day") < this.$moment(this.today)) addFlg = false;
                    //----------------------------------------------------
                    if (addFlg) {
                        let sdate = this.$moment(this.dispDate).add(i, "day").format("YYYY-MM-DD ") + feedPlan.stime;
                        let edate = this.$moment(sdate).add(feedPlan, "minutes").format("YYYY-MM-DD HH:mm");
                        let color = "black";
                        if (feedPlan.mode == "timer") color = "green";
                        if (feedPlan.mode == "self") color = "orange";
                        if (feedPlan.mode == "ai") color = "pink";
                        this.events.push({
                            id: feedPlan.id,
                            primaryKey: feedPlan.id,
                            name: feedPlan.name,
                            start: sdate,
                            end: edate,
                            color: color,
                        });
                    }
                }
            }
        },
        //===================================================
        // 新規プラン作成用ダイアログ表示
        //===================================================
        newFeedPlanClick(feedMode) {
            //-----------------------
            this.dlgFeedPlan = {
                id: 0,
                site_id: 0,
                device_id: 0,
                mode: "timer",
                name: "新規プラン",
                stime: "06:30",
                minutes: "90",
                routine: ["月", "水", "金"],
                zero_date: this.$moment().format("YYYY-MM-DD"),
                splinkle: 3,
                detail: {
                    timer_weight: "100",

                    ai_start_motor: "3",
                    ai_start_delay: "30",
                    ai_lvl5_motor: "5",
                    ai_lvl4_motor: "4",
                    ai_lvl3_motor: "3",
                    ai_lvl2_motor: "2",
                    ai_lvl1_motor: "1",
                    ai_sensitive: "2", // 1=敏感、3＝鈍感
                    ai_repeat: "1",
                    ai_repeat_interval: "10",

                    self_shot_weight: "10", //自発のショット給餌量
                    self_sunrise: "15", //日の出まずめ
                    self_sunset: "15",
                    self_extra: "1.5", //増量
                    self_region_code: "A", //地域コード
                },
            };
            //-----------------------
            this.dlgFeedPlan.mode = feedMode;
            this.dlgFeedPlan.id = 0;
            this.dlgFeedPlan.name = "新規プラン";
            this.dlgFeedPlan.stime = this.$moment().format("HH:mm");
            this.dlgFeedPlan.minutes = "30";
            this.dlgFeedPlan.zero_date = this.$moment().format("YYYY-MM-DD");
            this.dlgFeedPlan.routine = ["毎日"];
            this.routineChange(this.dlgFeedPlan.routine);
            this.dispPlanDlg = true;
            this.calcOutputMinMax();
        },
        //===================================================
        // 既存プランの変更ダイアログ表示
        //===================================================
        feedPlanClick(e) {
            const primaryKey = e.event.primaryKey;
            for (let plan of this.dbFeedPlans) {
                if (plan.id == primaryKey) {
                    this.dlgFeedPlan = JSON.parse(JSON.stringify(plan));
                    this.calcOutputMinMax();
                    break;
                }
            }
            this.routineChange(this.dlgFeedPlan.routine);
            this.dispPlanDlg = true;
        },
        //===================================================
        // デバイス＝イケス
        //===================================================
        async axiosGetDevices(device_id) {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: { id: device_id, "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbDevice = response.data.json[0];
            });
        },
        //===================================================
        // 給餌機
        //===================================================
        async axiosGetFeeders(feeder_id) {
            await this.axios({
                method: "GET",
                url: "/web/api/feeders",
                params: { id: feeder_id, "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbFeeder = response.data.json[0];
            });
        },
        //===================================================
        // 給餌プランDataを取得
        //===================================================
        async axiosGetFeedPlan() {
            await this.axios({
                method: "GET",
                url: "/web/api/feed_plans",
                params: { device_id: this.device_id },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbFeedPlans = response.data.json;
                for (let i in this.dbFeedPlans) {
                    let detail = this.dbFeedPlans[i]["detail"];
                    detail = String(detail).split('\\"').join('"');
                    this.dbFeedPlans[i]["detail"] = JSON.parse(detail);
                    //----------------------------------------
                    let routine = this.dbFeedPlans[i]["routine"];
                    routine = String(routine).split('\\"').join('"');
                    this.dbFeedPlans[i]["routine"] = JSON.parse(routine);
                }
                this.createWeekEvent();
            });
        },
        //===================================================
        // 給餌プランDataをサブミット
        //===================================================
        async axiosSubmitFeedPlan() {
            let ErrCount = 0;
            if (!this.dlgFeedPlan["name"]) ErrCount++;
            if (!this.dlgFeedPlan["stime"]) ErrCount++;
            if (!this.dlgFeedPlan["minutes"]) ErrCount++;
            if (this.dlgFeedPlan["routine"].length == 0) ErrCount++;
            if (ErrCount) {
                alert("未入力項目があります。");
                return false;
            }
            //-----------------------------------
            if (this.dlgFeedPlan.mode == "timer") {
                let weight = this.dlgFeedPlan.detail.timer_weight;
                if (Math.round(Number(weight) * 10) / 10 !== Number(this.dlgFeedPlan.detail.timer_weight)) {
                    alert("給餌量の値が不正です。");
                    return false;
                }
                if (weight < this.outputMin || this.outputMax < weight) {
                    alert("給餌量が範囲を超えています。");
                    return false;
                }
            }
            //-----------------------------------
            if (this.dlgFeedPlan.mode == "self") {
                let weight = this.dlgFeedPlan.detail.self_shot_weight;
                if (Math.round(Number(weight) * 10) / 10 !== Number(this.dlgFeedPlan.detail.self_shot_weight)) {
                    alert("給餌量の値が不正です。");
                    return false;
                }
                if (weight < 0.1 || 3.0 < weight) {
                    alert("1回あたりの給餌量が範囲を超えています。");
                    return false;
                }
            }
            //-----------------------------------
            this.isLoading = true;
            this.dispPlanDlg = false;
            //-----------------------------------
            let routineAry = JSON.parse(JSON.stringify(this.dlgFeedPlan["routine"]));
            this.dlgFeedPlan["routine"] = [];
            for (let obj of this.optRoutines) {
                let val = obj.value;
                if (routineAry.includes(val)) {
                    this.dlgFeedPlan["routine"].push(val);
                }
            }
            //-----------------------------------
            const axiosData = JSON.parse(JSON.stringify(this.dlgFeedPlan));
            axiosData["site_id"] = this.myInfo.site_id;
            axiosData["device_id"] = this.device_id;
            axiosData["feeder_id"] = this.dbDevice.feeder_id;
            axiosData["routine"] = JSON.stringify(axiosData["routine"]);
            axiosData["detail"] = JSON.stringify(axiosData["detail"]);
            //-----------------------------------
            const primaryKey = this.dlgFeedPlan.id;
            let restMethod = "PUT";
            if (primaryKey == 0) restMethod = "POST";

            let restUrl = "/web/api/feed_plans";
            if (primaryKey > 0) restUrl = restUrl + "/" + primaryKey;

            await this.axios({
                method: restMethod,
                url: restUrl,
                headers: { Authorization: "Bearer " + this.jwt },
                data: axiosData,
                timeout: 30000,
            })
                .then(() => {
                    this.axiosGetFeedPlan();
                    this.mqttFeedPlansChange();
                })
                .catch(function (error) {
                    if (error.response.data.err == "ER_DUP_ENTRY") {
                        alert("重複しています。\n保存できません。");
                    } else {
                        alert("ん？ " + error.response.data.err);
                    }
                });
            //-----------------------------------
            await new Promise((r) => setTimeout(r, 1000));
            this.isLoading = false;
        },
        //===================================================
        // 給餌プランDataを削除
        //===================================================
        async axiosDeleteFeedPlan() {
            this.confirmDeleteDlg = false;
            this.dispPlanDlg = false;
            this.isLoading = true;
            //-------------------------
            const PrimaryKey = this.dlgFeedPlan.id;
            await this.axios({
                method: "DELETE",
                url: "/web/api/feed_plans/" + PrimaryKey,
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then(() => {
                this.axiosGetFeedPlan();
                this.mqttFeedPlansChange();
            });
            await new Promise((r) => setTimeout(r, 1000));
            this.isLoading = false;
        },
        //===================================================
        //====================================================
        async connectMqtt() {
            //-----------------
            if (this.mqttClient.connected) return true;
            //-----------------
            //const gThis = this;
            //-----------------
            this.mqttClient = mqtt.connect(
                this.mqttHost
                //{ username: this.mqttID, password: this.mqttPW }
            );
            //-----------------
            this.mqttClient.on("connect", function () {
                self.console.log("MQTT Connected !!");
            });
            //-----------------
        },
        //====================================================
        disconnectMqtt() {
            if (!this.mqttClient.connected) return true;
            this.mqttClient.end();
        },
        //====================================================
        publishMessage(mac, key, val) {
            const topic = this.mqttTopicPub + "/" + mac;
            const pubMessage = { type: "order", key: key, val: val, mac: mac };
            if (this.mqttClient.connected) {
                this.mqttClient.publish(topic, JSON.stringify(pubMessage));
            }
        },
        //====================================================
        mqttFeedPlansChange() {
            const mac = this.dbDevice["mac"];
            const key = "feed_plans";
            const val = "change";
            this.publishMessage(mac, key, val);
        },
        //====================================================
    },
    //#####################################################################################################
};
</script>
